// Proezi · Startseite: kleine Helfer für die eigenen Sections (Vorlage: prototypen/homepage/FINAL-startseite)
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

document.documentElement.classList.add('pz-js');

// Etikett: .sichtbar startet Striche, Unterstrich und Biene, sobald der Abschnitt ins Bild kommt
const beobachten = (wurzel = document) => {
  const ziele = wurzel.querySelectorAll('[data-pz-sichtbar]:not(.sichtbar)');
  if (!('IntersectionObserver' in window)) { ziele.forEach((z) => z.classList.add('sichtbar')); return; }
  const beobachter = new IntersectionObserver((eintraege) => eintraege.forEach((e) => {
    if (e.isIntersecting) { e.target.classList.add('sichtbar'); beobachter.unobserve(e.target); }
  }), { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
  ziele.forEach((z) => beobachter.observe(z));
};

// Hinweis unten nach „In den Warenkorb“
let toast;
const melden = (text) => {
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'pz-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.append(toast);
  }
  toast.textContent = text;
  toast.classList.add('zeigen');
  clearTimeout(toast._t);
  toast._t = setTimeout(() => toast.classList.remove('zeigen'), 3000);
};

const HAKEN = '<svg class="haken" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M4 10.5 8.2 14.5 16 5.5"/></svg>';

// In den Warenkorb ohne Seitenwechsel; ohne JS schickt das Formular normal an /cart/add
document.addEventListener('submit', async (ereignis) => {
  const form = ereignis.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-pz-korb]')) return;
  ereignis.preventDefault();
  const knopf = form.querySelector('button[type="submit"]');
  if (!knopf || knopf.disabled) return;
  knopf.disabled = true;

  const daten = new FormData(form);
  const zugesagt = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add',
    context: 'product',
    lines: [{ merchandiseId: String(daten.get('id')), quantity: Number(daten.get('quantity')) || 1 }],
    promise: zugesagt.promise,
  }));

  try {
    const antwort = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: daten,
    });
    const ergebnis = await antwort.json();
    if (!antwort.ok || ergebnis.status) throw new Error(ergebnis.description || ergebnis.message || 'Fehler');

    const korb = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart.js`).then((r) => r.json());
    zugesagt.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(korb),
      detail: { items: korb.items, itemCount: korb.item_count, source: 'proezi-sortiment' },
    });

    if (!knopf.dataset.text) knopf.dataset.text = knopf.innerHTML;
    knopf.innerHTML = `${HAKEN}${knopf.dataset.erledigt || 'Liegt im Korb'}`;
    knopf.classList.add('erledigt');
    melden(`${form.dataset.name} liegt im Warenkorb.`);
    clearTimeout(knopf._t);
    knopf._t = setTimeout(() => { knopf.innerHTML = knopf.dataset.text; knopf.classList.remove('erledigt'); }, 2000);
  } catch (fehler) {
    zugesagt.reject(fehler);
    melden(fehler.message || 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.');
  } finally {
    knopf.disabled = false;
  }
});

// Newsletter: freundliche Prüfung vor dem Absenden
document.addEventListener('submit', (ereignis) => {
  const form = ereignis.target;
  if (!(form instanceof HTMLFormElement) || !form.closest('.pz-post')) return;
  const feld = form.querySelector('input[type="email"]');
  const meldung = form.querySelector('.post__meldung');
  if (!feld || !meldung) return;
  if (!feld.value.trim() || !feld.checkValidity()) {
    ereignis.preventDefault();
    feld.setAttribute('aria-invalid', 'true');
    meldung.classList.add('post__meldung--fehler');
    meldung.textContent = feld.value.trim()
      ? 'Bitte prüfe die Adresse, zum Beispiel name@beispiel.de.'
      : 'Bitte gib deine E-Mail-Adresse ein.';
    feld.focus();
  }
}, true);

// Produktseite: Größe wählen, Menge, Bilder, Kaufleiste am Handy
const produktSeite = (wurzel = document) => {
  wurzel.querySelectorAll('[data-pz-produkt]').forEach((sektion) => {
    if (sektion.dataset.bereit) return;
    sektion.dataset.bereit = '1';
    const form = sektion.querySelector('form[data-pz-korb]');
    const idFeld = sektion.querySelector('[data-pz-variante]');
    const kaufen = sektion.querySelector('[data-pz-kaufen]');
    const leisteKnopf = sektion.querySelector('[data-pz-leiste-kaufen]');

    sektion.querySelectorAll('.groesse__wahl input').forEach((wahl) => wahl.addEventListener('change', () => {
      if (!wahl.checked) return;
      idFeld.value = wahl.value;
      sektion.querySelectorAll('[data-pz-preis]').forEach((e) => { e.textContent = wahl.dataset.preis; });
      sektion.querySelectorAll('[data-pz-grund]').forEach((e) => { e.textContent = wahl.dataset.grund; });
      sektion.querySelectorAll('[data-pz-titel]').forEach((e) => { e.textContent = wahl.dataset.titel; });
      kaufen.disabled = false; kaufen.textContent = 'In den Warenkorb';
      if (leisteKnopf) leisteKnopf.disabled = false;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', wahl.value);
      window.history.replaceState({}, '', url);
    }));

    sektion.querySelectorAll('.menge').forEach((m) => {
      const feld = m.querySelector('input');
      m.querySelectorAll('button').forEach((b) => b.addEventListener('click', () => {
        feld.value = Math.max(1, Math.min(99, (parseInt(feld.value, 10) || 1) + Number(b.dataset.schritt)));
      }));
    });

    const haupt = sektion.querySelector('[data-pz-hauptbild]');
    sektion.querySelectorAll('[data-pz-daumen]').forEach((d) => d.addEventListener('click', () => {
      if (!haupt) return;
      haupt.removeAttribute('srcset');
      haupt.src = d.dataset.gross;
      haupt.alt = d.dataset.alt;
      sektion.querySelectorAll('[data-pz-daumen]').forEach((x) => x.removeAttribute('aria-current'));
      d.setAttribute('aria-current', 'true');
    }));

    if (leisteKnopf && form) leisteKnopf.addEventListener('click', () => form.requestSubmit());
    const leiste = sektion.querySelector('.leiste');
    if (leiste && kaufen && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        leiste.classList.toggle('zeigen', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(kaufen);
    }
  });
};

// Rezept: Zutaten-Etikett als Einkaufsliste. Summe der angehakten Produkte; alles Angehakte auf einmal in den Warenkorb.
const euroFormat = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
const einkaufsliste = (wurzel = document) => {
  wurzel.querySelectorAll('form[data-pz-mehrfach]').forEach((form) => {
    if (form.dataset.bereit) return;
    form.dataset.bereit = '1';
    const summe = form.querySelector('[data-pz-summe]');
    const knopf = form.querySelector('button[type="submit"]');
    const haken = form.querySelectorAll('input[type="checkbox"]');
    const neu = () => {
      const cent = [...haken].filter((h) => h.checked).reduce((a, h) => a + Number(h.dataset.cent), 0);
      if (summe) summe.textContent = euroFormat.format(cent / 100);
      if (knopf) knopf.disabled = cent === 0;
    };
    haken.forEach((h) => h.addEventListener('change', neu));
  });
};
document.addEventListener('submit', async (ereignis) => {
  const form = ereignis.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-pz-mehrfach]')) return;
  ereignis.preventDefault();
  const items = [...form.querySelectorAll('input[type="checkbox"]:checked')].map((h) => ({ id: Number(h.value), quantity: 1 }));
  const knopf = form.querySelector('button[type="submit"]');
  if (!items.length || !knopf) return;
  knopf.disabled = true;
  const zugesagt = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add',
    context: 'product',
    lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: 1 })),
    promise: zugesagt.promise,
  }));
  const wurzel = window.Shopify?.routes?.root ?? '/';
  try {
    const antwort = await fetch(`${wurzel}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    const ergebnis = await antwort.json();
    if (!antwort.ok || ergebnis.status) throw new Error(ergebnis.description || ergebnis.message || 'Fehler');
    const korb = await fetch(`${wurzel}cart.js`).then((r) => r.json());
    zugesagt.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(korb),
      detail: { items: korb.items, itemCount: korb.item_count, source: 'proezi-rezept' },
    });
    if (!knopf.dataset.text) knopf.dataset.text = knopf.innerHTML;
    knopf.innerHTML = `${HAKEN}Liegt im Korb`;
    knopf.classList.add('erledigt');
    melden(items.length === 1 ? '1 Produkt liegt im Warenkorb.' : `${items.length} Produkte liegen im Warenkorb.`);
    clearTimeout(knopf._t);
    knopf._t = setTimeout(() => { knopf.innerHTML = knopf.dataset.text; knopf.classList.remove('erledigt'); }, 2000);
  } catch (fehler) {
    zugesagt.reject(fehler);
    melden(fehler.message || 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.');
  } finally {
    knopf.disabled = false;
  }
});

// Schublade: das gerade dazugelegte Produkt bekommt „Gerade dazugelegt“ mit Häkchen.
// Die Schublade wird nach dem Hinzufügen neu gezeichnet; deshalb wird kurz beobachtet und nach jeder Änderung neu markiert.
document.addEventListener(StandardEvents.cartLinesUpdate, (ereignis) => {
  if (ereignis.action !== 'add') return;
  const ids = (ereignis.lines || []).map((l) => String(l.merchandiseId ?? l.id ?? '').split('/').pop()).filter(Boolean);
  if (!ids.length) return;
  ereignis.promise?.then(() => {
    const schublade = document.getElementById('cart-drawer');
    if (!schublade) return;
    const markieren = () => schublade.querySelectorAll('.kz').forEach((zeile) => {
      const marke = zeile.querySelector('.kz__neu');
      const neu = ids.includes(zeile.dataset.variantId);
      if (marke && marke.hidden === neu) marke.hidden = !neu;
    });
    markieren();
    const beobachter = new MutationObserver(markieren);
    beobachter.observe(schublade, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    setTimeout(() => beobachter.disconnect(), 4000);
  }).catch(() => {});
});

beobachten();
produktSeite();
einkaufsliste();
document.addEventListener('shopify:section:load', (e) => einkaufsliste(e.target));
// Theme-Editor: neu geladene Sections ebenfalls einrichten
document.addEventListener('shopify:section:load', (e) => { beobachten(e.target); produktSeite(e.target); });

// Rechtstexte („Weißes Blatt“): langes Wort im Titel an der Wortfuge trennbar machen; ab 6 Abschnitten
// ein Verzeichnis „Auf dieser Seite“ aus den Zwischenüberschriften, gleich unter den Titel gesetzt.
(() => {
  const blatt = document.querySelector('.pz-recht .rt-blatt');
  if (!blatt) return;
  const titel = blatt.querySelector('.shopify-policy__title h1');
  if (titel) {
    titel.textContent = titel.textContent
      .replace('Datenschutzerklärung', 'Datenschutz­erklärung')
      .replace('Widerrufsbelehrung', 'Widerrufs­belehrung')
      .replace('Geschäftsbedingungen', 'Geschäfts­bedingungen')
      .replace('Versandbedingungen', 'Versand­bedingungen');
  }
  const box = blatt.querySelector('[data-rt-toc-box]');
  const h2 = [...blatt.querySelectorAll('.shopify-policy__body h2')];
  if (!box) return;
  if (h2.length < 6) { box.remove(); return; }
  box.querySelector('[data-rt-toc]').innerHTML = h2.map((h, i) => {
    h.id ||= `abschnitt-${i + 1}`;
    const a = document.createElement('a');
    a.href = `#${h.id}`;
    a.textContent = h.textContent;
    return `<li>${a.outerHTML}</li>`;
  }).join('');
  box.querySelector('[data-rt-toc-zahl]').textContent = `${h2.length} Abschnitte`;
  titel?.closest('.shopify-policy__title')?.after(box);
  box.hidden = false;
})();
